export default () => {
    return sessionStorage.removeItem('app_key')
}